<template>
    <div class="field grid">
        <label for="name" class="col-12 mb-2 md:col-2 md:mb-0">Isi Doc </label>
        <div class="col-12 md:col-10">
            <InputText id="isi_doc" type="text" :class="{'p-invalid' : errors.isi_doc}" v-model="modelValue.isi_doc" />
            <small v-if="errors.isi_doc" id="name-help" class="p-error">{{errors.isi_doc}}</small>
        </div>
    </div>
</template>

<script>
import DataTable from "primevue/datatable";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Menubar from "primevue/menubar";
import Calendar from 'primevue/calendar';
import {FilterMatchMode} from "primevue/api";
import { useForm } from "@inertiajs/inertia-vue3"
import Column from "primevue/column";
import Button from "primevue/button";
import Divider from "primevue/divider";
import Card from "primevue/card";
import { Inertia } from '@inertiajs/inertia'
import MultiSelect from 'primevue/multiselect';
import DropdownWilayah from "../../../Components/DropdownWilayah.vue";

import BlockUI from "primevue/blockui";
import MapInput from "../../../Components/MapInput.vue";
import MapDisplayPoint from "../../../Components/MapDisplayPoint.vue";
import Dialog from "primevue/dialog";

export default {
    components: {
        Menubar,
        DataTable,
        Column, 
        Button,
        InputText,
        Password,
        Card,
        Divider,
        MultiSelect,
        Calendar,
        DropdownWilayah,
        BlockUI,
        MapInput,
        MapDisplayPoint,
        Dialog
    },
    props : {
        modelValue : {
            type : Array,
            default : () => []
        },
        errors : {
            type : Object,
            default : () => {}
        }
    },
    data : function(){
        return {
        }
    },
    methods : {
        
    },
    computed : {
        model : {
            get : function() {
                return this.modelValue;
            },
            set : function(value) {
                this.$emit('update:modelValue', value);
            }
        }
    }

}
</script>

<style>

</style>